import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/creators/{creatorId}/payments.csv']['GET'];

type GetPaymentsResponse = ThisApi['response'];

const getPaymentsCsv = async ({ creatorId, search, filter, startDate, endDate }: ThisApi['params'] & ThisApi['query']): Promise<GetPaymentsResponse> => {
  const response = await noodleApiClient.get(`/creators/${creatorId}/payments.csv`, {
    params: {
      endDate,
      filter,
      search,
      startDate,
    },
  });
  return response.data;
};

export default getPaymentsCsv;
